import Vue from 'vue';

Vue.prototype.$APP_NAME= location.hostname;
Vue.prototype.$APP_URL= location.origin;
